<div class="actions-container" *appHideIfNotInRole="['vessels-crew-change-editor']">
  <button
    mat-stroked-button
    color="primary"
    [matMenuTriggerFor]="actionsMenu"
    class="actions-btn"
    >
    Actions
    <mat-icon>arrow_drop_down</mat-icon>
  </button>

  <mat-menu #actionsMenu="matMenu">
    <button mat-menu-item (click)="cancelAll()">
      <span>Cancel All</span>
    </button>

    <button mat-menu-item (click)="delete()">
      <span>Delete</span>
    </button>

    @if (crewChange?.contract) {
      <button
        mat-menu-item
        (click)="addContractExtension()"
        >
        <span>Add contract extension</span>
      </button>
    }
  </mat-menu>
</div>
